module.exports = __webpack_public_path__ + "static/img/join5.00ccd62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/join5.jpg
// module id = CDM9
// module chunks = 0